/**
 * Determines whether a location is hosted on the legacy Railway domain
 * and returns the canonical target URL on https://www.gigship.com, or null if no redirect is needed.
 *
 * @param {Location|{hostname?: string, pathname?: string, search?: string, hash?: string}} loc
 * @returns {string|null} Canonical target URL or null
 */
export function railwayRedirectTarget(loc) {
  if (!loc || typeof loc.hostname !== 'string') {
    return null;
  }

  const hostname = loc.hostname.toLowerCase();
  if (hostname.endsWith('.up.railway.app') || hostname === 'up.railway.app') {
    const pathname = loc.pathname || '';
    const search = loc.search || '';
    const hash = loc.hash || '';
    return `https://www.gigship.com${pathname}${search}${hash}`;
  }

  return null;
}
